@if (null != customer) {
  <div class="tabs-area icon-tab account-details-{{ brand }}">
    <nav>
        <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
            <a class="nav-item nav-link left-border-tab {{ informationTab }}" (click)="setActiveTab('infos', true)" id="nav-information-tab" data-toggle="tab" href="#nav-information" role="tab" aria-controls="nav-information" aria-selected="true"><span>INFOS PERSO</span></a>
            <a class="nav-item nav-link left-border-tab {{ addressTab }}" (click)="setActiveTab('adresses', true)" id="nav-address-tab" data-toggle="tab" href="#nav-address" role="tab" aria-controls="nav-address" aria-selected="false"><span>ADRESSES</span></a>
            <a class="nav-item nav-link left-border-tab {{ paymentTab }}" (click)="setActiveTab('paiement', true)" id="nav-payments-information-tab" data-toggle="tab" href="#nav-payments-information" role="tab" aria-controls="nav-payments-information" aria-selected="false"><span>MOYENS DE PAIEMENT</span></a>
            <a class="nav-item nav-link left-border-tab right-border-tab {{ managementAccountTab }}" (click)="setActiveTab('gestion', true)" id="nav-management-account-tab" data-toggle="tab" href="#nav-management-account" role="tab" aria-controls="nav-management-account" aria-selected="false"><span>GESTION DU COMPTE</span></a>
            @if (notificationsPaginator?.data?.length > 0) {
                <a class="nav-item nav-link right-border-tab {{ notificationsTab }}" (click)="setActiveTab('notifications', true)"  id="nav-notifications-tab" data-toggle="tab" href="#nav-notifications" role="tab" aria-controls="nav-notifications" aria-selected="false">
                    <span>NOTIFICATIONS</span>
                    <app-notif-bell [notificationsNumber]="notificationsPaginator?.totalUnread"></app-notif-bell>
                </a>
            }
        </div>
    </nav>
    <!-- ************************************************************************************  Mes infos perso ******************************************  ****************************************** -->
    <div class="tab-content p-3" id="nav-tabContent">
        <div class="tab-pane fade show {{ informationTab }}" id="nav-information" role="tabpanel" aria-labelledby="nav-information-tab">
            @if (!handleRgpd) {
                <div>
                    <div class="info-perso-grid">
                        <div class="content">
                            <div class="grid">
                                <div><strong>Titulaire du compte :</strong></div>
                                <div id="customer-full-name">{{ customer.civility + ' ' + customer.firstName + ' ' + customer.lastName }}</div>
                            </div>
                            <div class="grid">
                                <div><strong>N° client :</strong></div>
                                <div id="customer-id">{{ customer.id }}</div>
                            </div>
                        </div>

                        <div class="content">
                            <div class="grid">
                                <div><strong>N° téléphone :</strong></div>
                                <div id="customer-phone-number">{{ customer.phoneNumber }}</div>
                            </div>
                            <div class="grid">
                                <div><strong>Email :</strong></div>
                                <div id="customer-email">{{ customer.email }}</div>
                            </div>
                        </div>
                        @if (!isPro) {
                            <div class="content">
                                <div class="grid">
                                    <div><strong>Date de naissance :</strong></div>
                                    <div>{{ formatDate(customer.birthDate) }}</div>
                                </div>
                                <div class="grid">
                                    <div><strong>Département de naissance :</strong></div>
                                    <div>{{ customer.birthDepartment }}</div>
                                </div>
                            </div>
                        } @else {
                            <div class="content">
                                <div class="grid">
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                </div>
                                <div class="grid">
                                    <div><strong>Société :</strong></div>
                                    <div>{{ customer.company ? customer.company : '-' }}</div>
                                </div>
                            </div>
                        }
                    </div>

                    @if (isPro) {
                        <div class="info-perso-grid">
                            <div class="content">
                                <div class="grid">
                                    <div><strong>SIRET :</strong></div>
                                    <div>{{ customer.siret }}</div>
                                </div>
                                <div class="grid">
                                    <div><strong>Référence acheteur (BT-10) :</strong></div>
                                    <div>{{ customer.buyerReference ? customer.buyerReference : '-' }}</div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="grid">
                                    <div>
                                        <strong>
                                            N° de TVA : <app-vies-status [customer]="customer"></app-vies-status>
                                        </strong>
                                    </div>
                                    <div>{{ customer.vatNumber ? customer.vatNumber : '-' }}</div>
                                </div>
                                <div class="grid">
                                    <div><strong>Référence marché (BT-12):</strong></div>
                                    <div>{{ customer.codeService ? customer.codeService : '-' }}</div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="grid">
                                    <div class="grid">
                                        <div><strong>Adresse de routage :</strong></div>
                                        <div>{{ customer.routingAddress ? customer.routingAddress : '-' }}</div>
                                    </div>
                                    <div class="grid">
                                        <div><strong>Référence bon de commande (BT-13) :</strong></div>
                                        <div>{{ customer.numeroCommande ? customer.numeroCommande : '-' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }


                    <div class="row">
                        <div class="col-12 text-center grid-data">
                            <button id="modify-number-btn" type="button" class="cta_btn level_2" (click)="updatePage()">Modifier<span></span></button>
                            @if (brand == 'lacarte') {
                                <button type="button" class="cta_btn level_2 ml-2" (click)="handleRgpd = !handleRgpd">Gérer mes données<span></span></button>
                            }
                        </div>
                    </div>
                </div>
            } @else {
                <div>
                    <app-customer-rgpd [procedureCode]="constHelper.PROCEDURE_CUSTOMER_RGPD"></app-customer-rgpd>
                </div>
            }
        </div>

        <!-- ************************************************************************************  Mes adresses ************************************************************************************ -->
        <div class="tab-pane fade show {{ addressTab }}" id="nav-address" role="tabpanel" aria-labelledby="nav-address-tab">
            @if (addressTab !== '') {
                <app-address-list></app-address-list>
            }
        </div>

        <!-- ************************************************************************************  Coordonnées bancaires ************************************************************************************ -->
        <div class="tab-pane fade show {{ paymentTab }}" id="nav-payments-information" role="tabpanel" aria-labelledby="nav-payments-information-tab">
            @if (paymentTab !== '') {
                <app-payment-methods-list></app-payment-methods-list>
            }
        </div>

        <!-- ************************************************************************************  Gestion du compte ************************************************************************************ -->
        <div class="tab-pane fade show {{ managementAccountTab }}" id="nav-management-account" role="tabpanel" aria-labelledby="nav-management-account-tab">
            @if (managementAccountTab !== '') {
                <app-account-management></app-account-management>
            }
        </div>

        <!-- ************************************************************************************ Notifications ************************************************************************************ -->
        @if (notificationsPaginator?.data?.length > 0) {
            <div class="tab-pane fade show {{ notificationsTab }}" id="nav-notifications" role="tabpanel" aria-labelledby="nav-notifications-tab">
                <app-notifications [notificationsPaginator]="notificationsPaginator" [type]="'account'"></app-notifications>
            </div>
        }
    </div>
  </div>
}
@if ([constHelper.PROCEDURE_EXPIRATION_CB, constHelper.PROCEDURE_PAYMENT_METHOD_CHANGE].indexOf(selectedProcedure) != -1) {
    <app-new-payment-card [procedureCode]="selectedProcedure"></app-new-payment-card>
}
<app-frequently-questions [faq]="faqPageCode"></app-frequently-questions>
